<template>
    <div class="goods_detail_info">
        <div class="common_header">
            <van-icon name="arrow-left" class="back_icon" @click="back"/>
            <span class="lh_title" v-if="goods_role_info">{{goods_role_info.otype == 1 ? '寄售详情': '担保详情'}}</span>
        </div>
        <van-pull-refresh v-model="isAllLoading" @refresh="onRefresh">
            <div class="status_box">
            <div class="status" v-if="goods">
                <span v-if="goods.status == 3">
                    <van-image class="icon" :src="require('../../assets/bx/acc/order_2-1.png')"/>
                    {{ goods.status_name }}
                </span>
                <span v-else-if="goods.status == 4">
                    <van-image class="icon" :src="require('../../assets/bx/acc/order_3-1.png')"/>
                    {{ goods.status_name }}
                </span>
                <span v-else-if="goods.status == 1">
                    <van-image class="icon" :src="require('../../assets/bx/acc/order_1-1.png')"/>
                    {{ goods.status_name }}
                </span>
                <span v-else-if="goods.status == 0">{{ goods.status_name || "商品不存在" }}</span>
                <span v-else>{{ goods.status_name }}</span>
            </div>
            <div class="ing" v-if="goods&&goods.status == 3">审核中，预计需要1-3个工作日</div>
            <div class="ing" v-if="goods_role_info&&goods_role_info.key">
                口令：<i>{{goods_role_info.key}}</i><img src="../../assets/version_1.3.0/pay/fuzhi.png" alt="" @click="copy(goods_role_info.key)"/>
            </div>
        </div>
        <div class="gd_box" v-if="goods_role_info&&goods_role_info.reason != ''&&(goods&&goods.status == 4)">
            <div class="tit">不通过的原因</div>
            <div class="cont reason">
                {{goods_role_info.reason}}
            </div>
        </div>
        <div class="gd_box">
            <div class="tit">角色信息</div>
            <div class="cont">
                <p>
                    <span>游戏</span>
                    <i>{{app_name}}</i>
                </p>
                <p>
                    <span>账号</span>
                    <i>{{account}}</i>
                </p>
                <p v-if="goods">
                    <span>角色名</span>
                    <i>{{ goods.role_name }}</i>
                </p>
                <p v-if="goods">
                    <span>区服信息</span>
                    <i>{{ goods.server_name }}</i>
                </p>
            </div>
        </div>
        <div class="gd_box">
            <div class="tit">寄售信息</div>
            <div class="cont">
                <p v-if="goods_role_info">
                    <span>交易方式</span>
                    <i>{{goods_role_info.otype == 1 ? '寄售' : '担保'}}</i>
                </p>
                <p v-if="goods">
                    <span>商品标题</span>
                    <i>{{goods.goods_name }}</i>
                </p>
                <p v-if="goods">
                    <span>售价</span>
                    <i>&yen;{{goods.price}}</i>
                </p>
                <!-- <p v-if="goods&&goods.margin">
                    <span>保证金</span>
                    <i>&yen;{{goods.margin}}</i>
                </p> -->
                <p v-if="goods_role_info&&goods_role_info.expire_day">
                    <span>上架天数</span>
                    <i>{{goods_role_info.expire_day}}天</i>
                </p>
                <p v-if="goods_role_info">
                    <span>手机号码</span>
                    <i>{{goods_role_info.phone}}</i>
                </p>
                <p v-if="goods_role_info">
                    <span>QQ号码</span>
                    <i>{{goods_role_info.qq}}</i>
                </p>
                <p v-if="goods&&goods.add_time">
                    <span>发布时间</span>
                    <i>{{goods.add_time}}</i>
                </p>
                <p v-if="goods&&goods.verify_time">
                    <span>上架时间</span>
                    <i>{{goods.verify_time}}</i>
                </p>
            </div>
        </div>

        <!-- 审核失败 -->
        <div class="buttons" v-if="goods&&goods.status == 4">
            <van-button color="var(--theme)" @click="kefu">
                <van-image class="icon kefu" :src="require('../../assets/bx/acc/kefu.png')"/>
                联系客服
            </van-button>

            <van-button color="var(--theme)" :loading="loading" @click="reup">
                <van-image class="icon" :src="require('../../assets/bx/acc/shangjia.png')" />
                重新上架
            </van-button>
        </div>
        <!-- 审核成功 -->
        <div class="buttons" v-else-if="goods&&goods.status == 1">
            <van-button  color="var(--theme)" :loading="loading" @click="downGoods(goods.id)" >
                <van-image class="icon xiajia" :src="require('../../assets/bx/acc/xiajia.png')" />
                下架
            </van-button>

            <van-button color="var(--theme)" @click="editPrice(goods.price)">
                <van-image class="icon bianji" :src="require('../../assets/bx/acc/bianji.png')" />
                编辑价格
            </van-button>
        </div>

        <!-- 审核中 -->
        <div class="buttons" v-else-if="goods&&goods.status == 3">
            <van-button color="var(--theme)" @click="kefu" >
                <van-image class="icon kefu" :src="require('../../assets/bx/acc/kefu.png')"/>
                联系客服
            </van-button>
            <van-button color="var(--theme)" :loading="loading" @click="editPrice(goods.price)">
                <van-image class="icon bianji" :src="require('../../assets/bx/acc/bianji.png')" />
               编辑价格
           </van-button>
        </div>
        </van-pull-refresh>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                loading: false,
                goods: null,
                account: '',
                app_name: '',
                goods_role_info: null,
                icon: '',
                app_id: '',
                isAllLoading: false,
                child_user_id: '',
                verify_time: '',
                currentServeTime: '',
                interval_time: 48 * 60 * 60 * 1000,//48小时
            }
        },
        computed: {
            goods_id() {
                return this.$route.query.id
            },
            userData() {
                return this.$store.getters.state.userData || {};
            },
            differTime() {
                return this.$store.state.differTime;
            },
        },
        created() {
            this.getTime()
        },
        mounted() {
            this.getDetail(this.goods_id)
        },
        methods: {
            getTime() {
                var now = new Date();
                this.currentServeTime = new Date(now.valueOf() - this.differTime);
            },
            back() {
                this.$router.go(-1)
                // if(this.$route.name == 'order.detail'&&this.$route.query.from == 'puton'){
                //   this.$router.push({
                //     name: 'sell'
                //   })
                // }else {
                //   this.$router.go(-1)
                // } 
            },
            onRefresh() {
                var that = this;
                this.isAllLoading = true
                setTimeout(() => {
                  that.getDetail(that.goods_id)
                  that.isAllLoading = false;
                }, 1000);
            },
            getDetail(goods_id) {
                this.$Ajax('goods-role/detail', {
                    goods_id
                }).then(rs => {
                    if (rs.code == 200) {
                        this.goods = rs.data.goods
                        this.account = rs.data.account
                        this.app_name = rs.data.app_name
                        this.icon = rs.data.icon
                        this.goods_role_info = rs.data.goods_role_info
                        this.app_id = rs.data.goods.app_id
                        this.child_user_id = rs.data.goods_role_info.child_user_id
                        this.verify_time = rs.data.goods.verify_time
                    }
                })
            },
            //联系客服
            kefu() {
                window.location.href = 'https://livechathuyu.gmmsj.com/index/index/kefu?u=6265f471b483e&platform=8&game_id=8889&game_name=G买卖&uid=8_'+ this.userData.user_id +'&phone=' + this.userData.username
            },
            // 下架商品接口
            downGoods(goods_id) {
                var that = this;
                // let endtime = new Date(that.verify_time.replace(/-/g, '/')).getTime() + this.interval_time;
                // let now = new Date(this.currentServeTime).getTime();
                // if(now < endtime) {
                //     this.$RModal.cantdown({
                //         noheader: true
                //     })
                //     return
                // }
                this.$RModal.downgoodsconfirm({
                    noheader: true,
                    selection: {
                        goods_id
                    },
                    onSuccess: () => {
                        that.getDetail(that.goods_id)
                    }
                })
            },
            //重新上架
            reup() {
                this.loading = true
                var params = {
                    app_id: this.app_id,
                    account_id: this.goods.account_id,
                    server_id: this.goods.server_id
                }
                if(this.child_user_id) {
                    params.child_user_id = this.child_user_id
                }
                this.$Ajax('goods-role/cp-rolelist',params,'post',{
                    timeout: 35000  // 设置35秒超时
                }).then(rs => {
                    if(rs.code == 200) {
                        if(rs.data.length > 0) {
                            var selection = {
                                app_id: this.app_id,
                                account_id:this.goods.account_id,
                                icon: this.icon,
                                roles: rs.data,
                                index: 2, //1卖道具  2卖角色
                                account:this.account,
                                from: 'order', //来源 从订单进入的
                            }
                            if(this.child_user_id) {
                                selection.child_user_id = this.child_user_id
                            }
                            this.$RModal.accounts({
                                noheader: true,
                                selection         
                            })
                        }else {
                            // 没查到角色 弹框
                            this.$RModal.norole({
                                noheader: true
                            })
                        }
                    }
                }).finally(() => {
                    setTimeout(() => {
                        this.loading = false
                    },1000)
                })
            },
            //编辑价格
            editPrice(price) {
                this.$RModal.editprice({
                    noheader:true,
                    selection: {
                        wide:true,
                        goods_id:this.goods_id,
                        price
                    },
                    onSuccess:() => {
                        this.getDetail(this.goods_id)
                    }
                })
            },
            copy(text) {
                var that = this
                this.$copyText(text).then(() => {
                  that.$toast("复制成功");
                });
            }
        },
        watch: {},
    }
</script>

<style lang="less" scoped>
    .goods_detail_info {
        .status_box {
            height: 9rem;
            background-color: #ffefe4;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            color: #000;
            overflow: hidden;
            padding-bottom: 1rem;
            margin-bottom: .5rem;
            border-top-left-radius: .5rem;
            border-top-right-radius: .5rem;
            z-index: 101;
            position: sticky;
            top: 5rem;
            transform: translateY(-.5rem);
            &::after {
                content: '';
                width: 100%;
                height: 2rem;
                border-radius: 3rem;
                position: absolute;
                bottom: -1rem;
                left: 0;
                background-color: var(--innerbgc);
            }
            .status {
                font-size: 1.6rem;
                font-weight: 700;
                margin-bottom: .3rem;
                span {
                    display: flex;
                    align-items: center;
                    color: var(--theme);
                    font-weight: 700;
                    .icon {
                        width: 2.4rem;
                        height: 2.6rem;
                        margin-right: 0.8rem;
                    }
                }
            }
            .ing {
                font-size: 1.2rem;
                display: flex;
                align-items: center;
                i {
                    color: #FF0000;
                    font-weight: 700;
                    font-size: 1.4rem;
                }
                img {
                    width: 1.6rem;
                    height: 1.6rem;
                    margin-left: 1rem;
                    cursor: pointer;
                }
            }
        }
        .gd_box {
            margin: 0 1rem 1rem;
            background-color: #fff;
            border-radius: 1rem;
            overflow: hidden;
            .tit {
                background: var(--theme);
                height: 3.6rem;
                line-height: 3.6rem;
                padding: 0 1rem;
                font-size: 1.6rem;
                font-weight: 500;
                color: #fff;
            }
            .cont {
                padding: 1.4rem 1rem;
                font-size: 1.4rem;
                p {
                    display: flex;
                    justify-content: space-between;
                    align-items: flex-start;
                    margin-bottom: 0.5rem;
                    font-size: 1.4rem;
                    color: #000;
                    &:nth-last-child(1) {
                        margin: 0;
                    }
                    span {
                        width: 5.6rem;
                        margin-right: 1.6rem;
                        text-align: justify;
                        text-align-last: justify;
                    }
                    i {
                        flex: 1;
                        word-break: break-all;
                        text-align: end;
                    }
                }
            }
        }
    }
    .buttons {
        margin: 1rem 1rem 5rem;
        background-color: var(--theme);
        display: flex;
        border-radius: 1rem;
        overflow: hidden;
        position: relative;
        .van-button {
            height: 4rem;
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 1.4rem;
            padding: 0;
            .van-button__text {
                display: flex;
                align-items: center;
                justify-content: center;
            }
            .icon {
                width: 2rem;
                height: 2rem;
                margin-right: 0.5rem;
                margin-bottom: 0.2rem;
                &.kefu {
                    transform: scale(1.1);
                }
                &.xiajia {
                    transform: scale(1.25);
                }
                &.bianji {
                    transform: scale(0.8);
                }
            }
        }
        &::before {
            content: "";
            width: 1px;
            height: 1.8rem;
            background-color: #fff;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%,-50%);
            z-index: 2;
        }
    }
    .down {
        margin: 1rem auto 5rem;
        display: block;
        width: 35.5rem;
        height: 4rem;
        border-radius: 1rem;
        font-size: 1.4rem;
    }
    .kefu_btn {
        margin: 1rem auto 5rem;
        display: block;
        width: 35.5rem;
        height: 4rem;
        border-radius: 1rem;
        font-size: 1.4rem;
        .van-button__text {
            display: flex;
            justify-content: center;
            align-items: center;
        }
        .icon {
            width: 2.2rem;
            height: 2.2rem;
            margin-right: 0.5rem;
            margin-bottom: 0.2rem;
        }
    }

.common_header {
    position: fixed;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    z-index: 10;
    width: 100%;
    max-width: 525px;
    height: 5rem;
    line-height: 5rem;
    background: url(../../assets/version_1.3.0/index/linear.png) no-repeat 0 -3.7rem / 100% 26.2rem;
    background-color: #fff;
    text-align: center;
    font-size: 1.6rem;
    .back_icon,
    .lh_title {
      color: #fff;
    }
    .back_icon {
      position: absolute;
      left: 1rem;
      top: 50%;
      transform: translateY(-50%);
      font-size: 2rem;
      cursor: pointer;
    }
}
.van-pull-refresh {
    padding-top: 5rem;
}
</style>